import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.css";
// import Vconsole from "vconsole";
import "@/style/page.scss"; // global css
// import Element from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";

import { Cascader } from "element-ui";
Vue.use(Cascader);
// let vConsole = new Vconsole();
// Vue.use(vConsole);
// 它会根据的手机尺寸来调整rem的基准值：html标签上的font-size。
import "amfe-flexible";
import "@/assets/icon/iconfont.css";
import "@/components/global.js";
import store from "./store/index";
import filters from "@/filters/index.js";
// import './libs/rem.js';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.use(Vant);

Vue.config.productionTip = false;

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount("#app");
